import React from 'react';
import useReveal from '../../hooks/useReveal';
import { portfolioData } from '../../data/portfolioData';

export default function Experience() {
  const { experience } = portfolioData;
  const [ref, shown] = useReveal();

  return (
    <section className="section" id="work" ref={ref}>
      <div className={`reveal ${shown ? 'in' : ''}`}>
        <span className="eyebrow">02 — Where I've built</span>
        <h2 className="section-title">
          Work <span className="outline-text">experience</span>
        </h2>
      </div>

      <div className="exp-list">
        {experience.map((job, i) => (
          <div
            className={`exp-item reveal ${shown ? 'in' : ''}`}
            key={job.id}
            style={{ transitionDelay: `${i * 0.1}s` }}
          >
            <div className="exp-left">
              <div className="exp-company">{job.company}</div>
              <div className="exp-period">{job.period}</div>
              {job.current && <div className="exp-live">Active</div>}
            </div>
            <div className="exp-right">
              <div className="exp-role">{job.role}</div>
              <p className="exp-summary">{job.summary}</p>
              <ul className="exp-highlights">
                {job.highlights.map((h, hi) => (
                  <li key={hi}>{h}</li>
                ))}
              </ul>
              <div className="chip-row exp-keywords">
                {job.keywords.map((k) => (
                  <span className="chip" key={k}>
                    {k}
                  </span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
